module.exports = __webpack_public_path__ + "static/media/cat_product.73467429.jpg";